import { render, staticRenderFns } from "./subs.vue?vue&type=template&id=6e6e0946&scoped=true&"
import script from "./subs.vue?vue&type=script&lang=js&"
export * from "./subs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6e0946",
  null
  
)

export default component.exports